import { useNavigate } from 'react-router';

import { useI18n } from '@app-velocity/i18n';
import { Button } from '@app-velocity/ui';

export const FailMessage = () => {
  const navigate = useNavigate();
  const { t } = useI18n();

  const navigateHome = () => {
    navigate('/');
  };

  return (
    <>
      <h1>{t('users:project_invitation.fail.title')}</h1>
      <p>{t('users:project_invitation.fail.description')}</p>

      <Button
        variant="contained"
        fullWidth
        color="primary"
        size="large"
        onClick={navigateHome}
      >
        {t('users:project_invitation.fail.go_to_home_page')}
      </Button>
    </>
  );
};
